export default "<app-proposals-list></app-proposals-list>";